// '#207f47', '#C8E6C9'
// '#feafaf', '#8f2642'
// '#afd2fe', '#24488b'
// '#8A5340', '#FEEDAF'
// '#8f2642', '#feafaf'
// '#C8E6C9', '#256029'

export default function Badge({ label, cor, fundo }) {
  return (
    <span
      className={'product-badge status-lowstock'}
      style={{
        backgroundColor: fundo,
        color: cor,
      }}
    >
      {label}
    </span>
  )
}
